@if (timereportForm) {
    <div class="form-container">
        <form (ngSubmit)="save(timereportForm.value, timereportForm.valid)" [formGroup]="timereportForm" novalidate>
            <div class="form-row">
                <mat-form-field class="mat-form-field-lg">
                    <input [matAutocomplete]="autoBudget" formControlName="budget" matInput
                           placeholder="Project (Budget) (Customer)"
                           type="text">
                    <mat-autocomplete #autoBudget="matAutocomplete" [displayWith]="budgetDisplayFn">
                        @for (budget of filteredBudgets | async; track budget) {
                            <mat-option [value]="budget">
                                <div [ngClass]="{'export-budget': budget.export }">
                                    <span>{{ budget.company?.companyName | ellipsis:20 }}-</span>
                                    @if (budget.project) {
                                        <span>{{ budget | projectNr }}&nbsp;-</span>
                                    }{{ budget.budgetNr }}
                                </div>
                            </mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
                @if (!singleSubBudget) {
                    <mat-form-field>
                        <mat-select [compareWith]="compareSubBudget" formControlName="subBudget" i18n-placeholder
                                    placeholder="Sub Budget">
                            @for (subbudget of subbudgets$ | async; track subbudget) {
                                <mat-option [value]="subbudget">
                                    {{ subbudget.description }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                }
                <mat-form-field class="mat-form-field-md">
                    <mat-select [compareWith]="compareActivity" formControlName="activity" i18n-placeholder
                                placeholder="Activity">
                        @for (activity of activities | async; track activity) {
                            <mat-option [value]="activity">
                                {{ activity?.activity }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field>
                    <input formControlName="hours" i18n-placeholder id="hours" matInput name="hours" placeholder="Hours"
                           required
                           type="number">
                </mat-form-field>
                <mat-form-field>
                    <input [matDatepickerFilter]="dateFilter" [matDatepicker]="picker" [max]="maxDate"
                           formControlName="date"
                           i18n-placeholder
                           matInput name="date" placeholder="Date" required>
                    <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <!--
                <mat-form-field>
                  <input matInput id="userId" placeholder="User" i18n-placeholder
                    required [(ngModel)]="model.userId" name="userId">
                  </mat-form-field>
                  -->
                @if (canChangeUser) {
                    <mat-form-field class="mat-form-field-lg">
                        <input [matAutocomplete]="autoUsers" formControlName="user" matInput placeholder="User" type="text">
                        <mat-autocomplete #autoUsers="matAutocomplete" [displayWith]="displayFn">
                            @for (user of filteredUsers | async; track user) {
                                <mat-option [value]="user">
                                    {{ user.email }}
                                </mat-option>
                            }
                        </mat-autocomplete>
                    </mat-form-field>
                } @else {
                    <input formControlName="user" type="hidden">
                }
            </div>
            <!-- <mat-form-field class="full-width">
            <textarea matInput  matTextareaAutosize matAutosizeMinRows="3"
            matAutosizeMaxRows="10" placeholder="Description" i18n-placeholder required formControlName="description" name="description"></textarea>
          </mat-form-field> -->
            <div class="NgxEditor__Wrapper">
                <ngx-editor-menu [editor]="editor"></ngx-editor-menu>
                <ngx-editor [editor]="editor" formControlName="description"></ngx-editor>
            </div>
            @if (timereportForm.get('description').hasError('minlength')) {
                <mat-error><span i18n>You should enter at least 4
        character!</span></mat-error>
            }
            @if (submitted && timereportForm.get('description').hasError('required')) {
                <mat-error><span i18n>You should enter a
        description!</span></mat-error>
            }
            <div class="button-row">
                <!-- <button type="submit" mat-raised-button [disabled]="!timereportForm.valid" i18n>{{ timereport ? 'Update Time Report' : 'Add Time Report' }}</button> -->
                <button i18n mat-raised-button type="submit">{{ timereport ? 'Update Time Report' : 'Add Time Report' }}
                </button>
                @if (timereport) {
                    <button (click)="cancelTimereportEdit()" i18n mat-raised-button>Cancel</button>
                }
            </div>
        </form>
    </div>
}